import {
  Activity,
  Coins,
  FolderKanban,
  Handshake,
  Home,
  Inbox,
  Package,
  Receipt,
  SlidersHorizontal,
  TrendingUp,
  UserCog,
  Users,
  Wallet,
  Wrench,
  type LucideIcon,
} from "lucide-react";

import type { NavGroupId, NavItemId } from "@/lib/auth/roles";

// Die Icons der Leiste — EIN Ort (NAV-4). Vorher lagen sie in TopNav.tsx;
// seit die Palette (⌘K) dieselben Ziele zeigt, lesen Leiste, Drawer und
// Palette hier. Ein Blatt, ein Icon, ueberall dasselbe.
export const ICONS_BY_NAV_ID: Record<NavItemId, LucideIcon> = {
  home: Home,
  customers: Users,
  projects: FolderKanban,
  invoices: Receipt,
  finanzen: TrendingUp,
  earnings: Coins,
  produkte: Package,
  team: UserCog,
  einstellungen: SlidersHorizontal,
  "partner-portal": Handshake,
  aktivitaeten: Activity,
  leads: Inbox,
};

// Icons fuer die Sammel-Dropdowns der Leiste (POL-2, seit NAV-1 fuer alle
// Rollen). Bewusst distinkt vom Zahnrad (System liegt im Konto-Menue).
export const ICONS_BY_GROUP_ID: Record<NavGroupId, LucideIcon> = {
  geld: Wallet,
  verwaltung: Wrench,
};
